<template>
    <div>
        Otomasyon görevi kredisi neredeyse bitmek üzere. %90 otomasyon görevi kredisi kullanıldı.
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "AutomationTaskCreditLow",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
